export default __webpack_public_path__ + "static/media/gmail.7bf1a224.svg";